var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@one-thd/sui-atomic-components';
import { getTextFieldStatus } from '../../../utils/form';
import { ZIPCODE_LENGTH } from '../../../constants/general';
import { useZipCode } from '../../../hooks/use-zipcode';
import { CityStateSelect } from '../city-state-select/city-state-select';
export const ZipCodeCitySelectFields = ({ spacingY, disabled, }) => {
    const { control, formState: { errors: formErrors }, getValues, setValue, trigger, } = useFormContext();
    const ySpacingClasses = {
        0: 'sui-gap-y-0',
        1: 'sui-gap-y-1',
        2: 'sui-gap-y-2',
        3: 'sui-gap-y-3',
        4: 'sui-gap-y-4',
        5: 'sui-gap-y-5',
    };
    const zipCodeValue = getValues('zipCode');
    const cityStateValue = getValues('cityState');
    const { isZipCodePending, zipCodeApiError, zipCodeNotFoundError, cities, cityState, loadCities, } = useZipCode(zipCodeValue, cityStateValue);
    useEffect(() => {
        setValue('cityState', cityState);
        setValue('isZipCodePending', isZipCodePending);
        setValue('isZipCodeApiError', zipCodeApiError);
        setValue('isZipCodeNotFoundError', zipCodeNotFoundError);
        if (zipCodeNotFoundError || zipCodeApiError) {
            trigger('zipCode');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityState, isZipCodePending, zipCodeApiError, zipCodeNotFoundError]);
    const handleZipCodeChange = (event) => {
        const newZipCode = event.currentTarget.value;
        loadCities(newZipCode);
    };
    const gapSpacing = (spacingY === null || spacingY === void 0 ? void 0 : spacingY.toString())
        ? ySpacingClasses[spacingY]
        : 'sui-gap-y-6';
    return (React.createElement("div", { className: `sui-grid ${gapSpacing}` },
        React.createElement(Controller, { name: "zipCode", control: control, disabled: disabled, render: ({ field }) => {
                var _a;
                const { ref, value, name, onChange } = field, rest = __rest(field, ["ref", "value", "name", "onChange"]);
                const onChangeRevised = (event) => {
                    handleZipCodeChange(event);
                    onChange(event);
                };
                return (React.createElement(TextField, { label: "ZIP Code*", status: getTextFieldStatus(formErrors.zipCode), statusMessage: (_a = formErrors.zipCode) === null || _a === void 0 ? void 0 : _a.message, value: value, name: name, onChange: onChangeRevised, InputProps: {
                        inputProps: Object.assign(Object.assign({}, rest), { maxLength: ZIPCODE_LENGTH, 'data-qm-mask': '', 'data-testid': 'zipCode' }),
                    } }));
            } }),
        React.createElement(Controller, { name: "cityState", control: control, disabled: disabled, render: ({ field }) => {
                const { ref, onChange, value } = field, rest = __rest(field, ["ref", "onChange", "value"]);
                return (React.createElement(CityStateSelect, Object.assign({ "data-testid": "cityState", cities: cities, onChange: onChange, value: value || '' }, rest)));
            } })));
};
